import React, { Component } from "react";
import { Link } from "react-router-dom";
import Aux from "../../../hoc/Auxilliary";
import { getCategories } from "../../../data-service";
import { setCategoryId } from "../../../localstorage-service";
import Spinner from "../Common/Spinner/Spinner";

class Home extends Component {
  state = {
    categories: [],
    showSpinner: false
  };
  showSpinner(isShow = false) {
    this.setState({
      showSpinner: isShow
    });
  }
  componentDidMount() {
    this.showSpinner(true);
    getCategories()
      .then(response => {
        this.showSpinner(false);
        this.setState({ categories: response.data });
      })
      .catch(error => {
        this.showSpinner(false);
        this.props.showError(error);
      });
  }
  categoryClicked(id) {
    setCategoryId(id);
  }
  render() {
    const categories = this.state.categories;
    let finalHtml = null;
    if (categories.length > 0) {
      finalHtml = (
        <Aux>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                <div className="row  category_container_bg01">
                  <div className="category_content">
                    <Link
                      onClick={() => this.categoryClicked(categories[0].Id)}
                      to={{
                        pathname: "/workflow",
                        state: { title: categories[0].Name, id: categories[0].Id },
                        params: { id: categories[0].Id }
                      }}
                    >
                      {categories[0].Name}
                    </Link>
                    <p>
                      {categories[0].Description}
                      {/* Click Workflow to view the videos <br />related to workflow. */}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row  category_container_bg02">
                  <div className="category_content">
                    <Link
                      onClick={() => this.categoryClicked(categories[1].Id)}
                      to={{
                        pathname: "/learning",
                        state: { title: categories[1].Name, id: categories[1].Id },
                        params: { id: categories[1].Id }
                      }}
                    >
                      {categories[1].Name}
                    </Link>
                    <p>
                      {categories[1].Description}
                      {/* Click Learning to view the modules <br />available within the Learning menu. */}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Aux>
      );
    }
    return (
      <Aux>
        <Spinner showSpinner={this.state.showSpinner} />
        {finalHtml}
      </Aux>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/containers/User/Home/Home.js